import { useRef, useState } from "react"
import { useSearchBox, UseSearchBoxProps } from "react-instantsearch"

export default function CustomSearchBox(props: UseSearchBoxProps) {
  const { query, refine } = useSearchBox(props)
  const [inputValue, setInputValue] = useState(query)
  const inputRef = useRef<HTMLInputElement>(null)

  function setQuery(newQuery: string) {
    setInputValue(newQuery)
    refine(newQuery)
  }

  return (
    <div className="flex-1 tablet:flex-none">
      <form
        action=""
        role="search"
        noValidate
        onSubmit={event => {
          event.preventDefault()
          event.stopPropagation()

          if (inputRef.current) {
            inputRef.current.blur()
          }
        }}
        onReset={event => {
          event.preventDefault()
          event.stopPropagation()
          setQuery("")

          if (inputRef.current) {
            inputRef.current.focus()
          }
        }}
      >
        <input
          ref={inputRef}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder="Search..."
          spellCheck={false}
          maxLength={512}
          type="search"
          value={inputValue}
          onChange={event => {
            setQuery(event.currentTarget.value)
          }}
          autoFocus
          className="w-full text-14 font-medium border border-black-30 hover:border-black bg-white hover:bg-black-10 py-12 px-16 rounded-full focus:outline-none transition-all [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-cancel-button]:h-16 [&::-webkit-search-cancel-button]:w-16 [&::-webkit-search-cancel-button]:cursor-pointer [&::-webkit-search-cancel-button]:bg-[url('data:image/svg+xml;utf8,<svg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%2020%2020%22%20fill=%22%23171A1B%22><path%20d=%22M6.28%205.22a.75.75%200%2000-1.06%201.06L8.94%2010l-3.72%203.72a.75.75%200%20101.06%201.06L10%2011.06l3.72%203.72a.75.75%200%20101.06-1.06L11.06%2010l3.72-3.72a.75.75%200%2000-1.06-1.06L10%208.94%206.28%205.22z%22/></svg>')] [&::-webkit-search-cancel-button]:bg-no-repeat [&::-webkit-search-cancel-button]:bg-center"
        />
      </form>
    </div>
  )
}
